<div class="ehrTab-container">
    <div class="ehrTab-content">
        <ng-template appComponentHost></ng-template>
    </div>
</div>